import { commonTypes } from '../common';

export const types = {
  SET_ADVERTISING_USE: 'APISNEEDS/SET_ALLOW_ADVERTISING_USE',
  SET_BACK_TO_SCHOOL_MAIL: 'APISNEEDS/SET_BACK_TO_SCHOOL_MAIL',
};

export const initialState = {
  addressInfo: null,
  clientInfo: null,
  originalPermanentResidenceInfo: { id: null },
  personalContactInfo: {
    contactPhone: null,
    email: null,
    advertisingUse: false,
  },
  updatePermanentResidenceNeeds: { id: null },
  clientAddresses: [],
  backToSchoolMail: null,
};

const ApisNeedsClientInfoReducer = (state, action) => {
  switch (action.type) {
    case commonTypes.SET_CLIENT_INFO: {
      const {
        additionalInfo,
        contactEmail,
        contactPhone,
        permanentResidence,
        docNumber,
        userIdPartyHash,
      } = action.payload;
      return {
        ...state,
        clientInfo: {
          docNumber,
          additionalInfo,
          contactEmail,
          contactPhone,
          userIdPartyHash,
        },
        originalPermanentResidenceInfo: {
          id: permanentResidence && permanentResidence.id,
          address: permanentResidence && permanentResidence.locationFullAddress,
        },
        personalContactInfo: {
          contactPhone: contactPhone ? contactPhone.value : null,
          email: contactEmail ? contactEmail.value : null,
        },
      };
    }
    case commonTypes.SET_ADDRESS_INFO: {
      const { locationId, fullAddress } = action.payload;
      return {
        ...state,
        addressInfo: {
          id: locationId,
          address: fullAddress,
        },
      };
    }
    case commonTypes.SET_SHIPPING_ADDRESS_NAME: {
      const { address } = action.payload;
      return {
        ...state,
        addressInfo: {
          ...state.addressInfo,
          address,
        },
      };
    }
    case commonTypes.SET_PERSONAL_CONTACT_INFO: {
      const { contactPhone, email } = action.payload;
      return {
        ...state,
        personalContactInfo: {
          ...state.personalContactInfo,
          contactPhone,
          email,
        },
      };
    }
    case types.SET_ADVERTISING_USE: {
      const { advertisingUse } = action.payload;
      return {
        ...state,
        personalContactInfo: {
          ...state.personalContactInfo,
          advertisingUse,
        },
      };
    }
    case commonTypes.SET_PERMANENT_RESIDENCE_INFO: {
      const { locationId } = action.payload;
      return {
        ...state,
        updatePermanentResidenceNeeds: {
          id: locationId,
        },
      };
    }
    case types.SET_BACK_TO_SCHOOL_MAIL: {
      const { backToSchoolMail } = action.payload;
      return {
        ...state,
        backToSchoolMail,
      };
    }
    default:
      return null;
  }
};

export const actions = {
  setAdvertisingUse: advertisingUse => ({
    type: types.SET_ADVERTISING_USE,
    payload: {
      advertisingUse,
    },
  }),
  setBackToSchoolMail: backToSchoolMail => ({
    type: types.SET_BACK_TO_SCHOOL_MAIL,
    payload: {
      backToSchoolMail,
    },
  }),
};

export default ApisNeedsClientInfoReducer;
